import FetchHelpers from "utils/FetchHelpers";
import { contentfulRoutes } from "routes";

export default {
  getSearchLinks() {
    return FetchHelpers.get(contentfulRoutes.menu());
  },
};
